var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"15px"}},[_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.limsOrders,"loading":_vm.isLoading},on:{"click:row":_vm.handleClick},scopedSlots:_vm._u([{key:"item.patient",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.patient.firstName)+" "+_vm._s(item.patient.fatherName)+" ")]}},{key:"item.collectedSampleID",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.collectedSampleID)+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }